import { render } from "./TariffsIndividualSparkKzEdit.vue?vue&type=template&id=6916cff8&scoped=true&ts=true"
import script from "./TariffsIndividualSparkKzEdit.vue?vue&type=script&lang=ts"
export * from "./TariffsIndividualSparkKzEdit.vue?vue&type=script&lang=ts"

import "./TariffsIndividualSparkKzEdit.vue?vue&type=style&index=0&id=6916cff8&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6916cff8"]])

export default __exports__